import { Box } from "@mui/material";
import { memo } from "react";
import { useAppContext } from "../context/appContext";

function KsbAppToolbarContainer({ isAdmin, children }) {
  const { isMobile, isTeacherView } = useAppContext();

  return (
    <Box
      sx={{
        display: "flex",
        overflowX: "auto", // ✅ enables scrolling
        scrollbarWidth: "none", // ✅ Firefox hide scrollbar
        "&::-webkit-scrollbar": { display: "none" }, // ✅ Chrome hide
        alignItems: "center",
        justifyContent:
          isAdmin && !isTeacherView ? "space-between" : "flex-start",
        flexWrap: "wrap",
        gap: 1.5,
        width: "100%",
        px: isMobile ? 1.5 : 0,
      }}
    >
      {children}
    </Box>
  );
}
export default memo(KsbAppToolbarContainer);
